(function () {
  if (window.KinokoAtcTracker) return;

  const LANDING_ATTRIBUTE_KEY = '_landing_url';
  const NAV_ATTRIBUTE_KEY = '_nav_log';
  const ATC_ATTRIBUTE_KEY = '_atc_log';
  const UPSELL_ATTRIBUTE_KEY = '_upsell_log';
  const REMOVE_ATTRIBUTE_KEY = '_remove_log';

  const LOCAL_NAV_KEY = 'kinoko_nav_log';
  const LOCAL_LANDING_KEY = 'kinoko_landing_url';
  const LOCAL_ATC_KEY = 'kinoko_atc_log';
  const LOCAL_UPSELL_KEY = 'kinoko_upsell_log';
  const LOCAL_REMOVE_KEY = 'kinoko_remove_log';
  const CHECKOUT_RETURN_PATH_KEY = 'kinoko_pre_checkout_path';

  const MAX_NAV_ITEMS = 30;
  const MAX_ACTION_ITEMS = 20;

  let queue = Promise.resolve();

  function root() {
    return window.Shopify?.routes?.root || '/';
  }

  function cleanPath() {
    return window.location.pathname || '/';
  }

  function logTime() {
    return new Date().toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      hour12: false
    });
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch {
      return fallback;
    }
  }

  function getLocalLandingUrl() {
    const currentUrl = window.location.href;

    try {
      let landing = localStorage.getItem(LOCAL_LANDING_KEY);

      if (!landing) {
        landing = currentUrl;
        localStorage.setItem(LOCAL_LANDING_KEY, landing);
      }

      return landing;
    } catch {
      return currentUrl;
    }
  }

  function getLocalLog(key, maxItems) {
    try {
      const log = parseJson(localStorage.getItem(key), []);
      return Array.isArray(log) ? log.slice(-maxItems) : [];
    } catch {
      return [];
    }
  }

  function saveLocalLog(key, log, maxItems) {
    try {
      localStorage.setItem(key, JSON.stringify(log.slice(-maxItems)));
    } catch {}
  }

  function getLocalNavLog() {
    return getLocalLog(LOCAL_NAV_KEY, MAX_NAV_ITEMS);
  }

  function saveLocalNavLog(log) {
    saveLocalLog(LOCAL_NAV_KEY, log, MAX_NAV_ITEMS);
  }

  function getLocalAtcLog() {
    return getLocalLog(LOCAL_ATC_KEY, MAX_ACTION_ITEMS);
  }

  function getLocalUpsellLog() {
    return getLocalLog(LOCAL_UPSELL_KEY, MAX_ACTION_ITEMS);
  }

  function getLocalRemoveLog() {
    return getLocalLog(LOCAL_REMOVE_KEY, MAX_ACTION_ITEMS);
  }

  function appendLocalActionLog(key, events) {
    if (!events.length) return;

    const currentLog = getLocalLog(key, MAX_ACTION_ITEMS);
    const nextLog = currentLog.concat(events).slice(-MAX_ACTION_ITEMS);

    saveLocalLog(key, nextLog, MAX_ACTION_ITEMS);
  }

  function rememberPreCheckoutPath() {
    try {
      const currentPath = cleanPath();

      if (currentPath && currentPath !== '/checkout') {
        sessionStorage.setItem(CHECKOUT_RETURN_PATH_KEY, currentPath);
      }
    } catch {}
  }

  function normalizeFakeHomepageBeforeCheckout(navLog) {
    if (navLog.length < 2) return navLog;

    const lastEvent = navLog[navLog.length - 1];
    const previousEvent = navLog[navLog.length - 2];

    if (!lastEvent || !previousEvent) return navLog;
    if (previousEvent.url !== '/checkout') return navLog;
    if (lastEvent.url !== '/') return navLog;

    try {
      const preCheckoutPath = sessionStorage.getItem(CHECKOUT_RETURN_PATH_KEY);

      if (preCheckoutPath && preCheckoutPath !== '/') {
        return navLog.slice(0, -1).concat({
          url: preCheckoutPath,
          time: lastEvent.time
        });
      }
    } catch {}

    return navLog;
  }

  function addCheckoutVisitLocally() {
    rememberPreCheckoutPath();

    const event = {
      url: '/checkout',
      time: logTime()
    };

    let navLog = getLocalNavLog();
    navLog = normalizeFakeHomepageBeforeCheckout(navLog);

    const lastEvent = navLog[navLog.length - 1];

    if (lastEvent && lastEvent.url === event.url) {
      lastEvent.time = event.time;
      saveLocalNavLog(navLog);
      return;
    }

    saveLocalNavLog(navLog.concat(event));
  }

  function normalizeAddedItems(addResponseJson) {
    const rawItems = Array.isArray(addResponseJson?.items)
      ? addResponseJson.items
      : [addResponseJson];

    return rawItems
      .filter(item => item && item.variant_id)
      .map(item => ({
        title: item.product_title || item.title || '',
        url: cleanPath(),
        time: logTime(),
        qty: Number(item.quantity || 1),
        variant: Number(item.variant_id)
      }));
  }

  function getAllTrackingAttributes() {
    return {
      [LANDING_ATTRIBUTE_KEY]: getLocalLandingUrl(),
      [NAV_ATTRIBUTE_KEY]: JSON.stringify(getLocalNavLog()),
      [ATC_ATTRIBUTE_KEY]: JSON.stringify(getLocalAtcLog()),
      [UPSELL_ATTRIBUTE_KEY]: JSON.stringify(getLocalUpsellLog()),
      [REMOVE_ATTRIBUTE_KEY]: JSON.stringify(getLocalRemoveLog())
    };
  }

  async function syncAllTrackingToCart() {
    queue = queue
      .catch(() => {})
      .then(async () => {
        const updateResponse = await fetch(root() + 'cart/update.js', {
          method: 'POST',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: getAllTrackingAttributes()
          })
        });

        if (!updateResponse.ok) {
          throw new Error('Kinoko tracking cart update failed');
        }
      });

    return queue;
  }

  function trackActionLocallyAndSync(localKey, events) {
    if (!events.length) return;

    appendLocalActionLog(localKey, events);
    return syncAllTrackingToCart();
  }

  window.KinokoAtcTracker = {
    trackFromAddResponse(addResponseJson) {
      return trackActionLocallyAndSync(
        LOCAL_ATC_KEY,
        normalizeAddedItems(addResponseJson)
      );
    },

    trackUpsellFromAddResponse(addResponseJson) {
      return trackActionLocallyAndSync(
        LOCAL_UPSELL_KEY,
        normalizeAddedItems(addResponseJson)
      );
    },

    trackRemove(item) {
      if (!item) return;

      return trackActionLocallyAndSync(LOCAL_REMOVE_KEY, [{
        title: item.title || item.product_title || '',
        url: cleanPath(),
        time: logTime(),
        qty: Number(item.qty || item.quantity || 1),
        variant: Number(item.variant || item.variant_id || 0)
      }]);
    },

    syncBeforeCheckout() {
      addCheckoutVisitLocally();
      return syncAllTrackingToCart();
    }
  };
})();